<script setup lang="ts">
</script>

<template>
    <nav class="flex w-full items-center justify-between px-4 py-5 text-sm text-white md:px-14 md:py-12 md:text-base">
        <div class="hidden items-center gap-6 md:flex">
            <a href="tel:0800737662" class="underline">0800 737 662</a>
            <a href="mailto:hello@resonatehealth.co.nz?subject=Enquiry%20from%20Rate%20Your%20Hearing" class="underline"
                >hello@resonatehealth.co.nz</a
            >
        </div>

        <a
            href="https://www.resonatehealth.co.nz"
            class="hover:underline md:hidden"
            >Visit Resonate Health</a
        >

        <div class="flex items-center gap-6">
            <div class="hidden items-center gap-6 md:flex">
                <a
                    href="https://www.resonatehealth.co.nz"
                    class="hover:underline"
                    >Visit Resonate Health</a
                >
            </div>

            <a
                href="https://www.resonatehealth.co.nz/studio-finder"
                class="flex items-center gap-2 hover:underline"
            >
                <img
                    src="/images/landing/pin-icon.svg"
                    alt=""
                    class="h-4 w-[10px]"
                />
                Studio Finder
            </a>
        </div>
    </nav>
</template>
